import {
  SupportAdmin,
  SupportCompanyDetail,
  SupportCompanyList,
  type SupportCompanyPatch,
  SupportCompanyRow,
  type SupportCreateCompanyRequest,
  SupportCreateCompanyResponse,
  SupportImpersonateResponse,
  type SupportLoginRequest,
  SupportLoginResponse,
} from '@siteday/shared';

import { api } from './client';

/** `/support/*` (doc 05 "Support"): the cookie `sd_support` is set by login. */
export const login = (input: SupportLoginRequest) => api.post('/support/auth/login', input, SupportLoginResponse);
export const me = () => api.get('/support/auth/me', SupportAdmin);
export async function logout(): Promise<void> {
  try {
    await api.post('/support/auth/logout', {});
  } catch {
    // Signing out locally is enough when the server call fails.
  }
}

export const listCompanies = () => api.get('/support/companies', SupportCompanyList);
export const getCompany = (id: string) => api.get(`/support/companies/${id}`, SupportCompanyDetail);
export const createCompany = (input: SupportCreateCompanyRequest) =>
  api.post('/support/companies', input, SupportCreateCompanyResponse);
export const patchCompany = (id: string, patch: SupportCompanyPatch) =>
  api.patch(`/support/companies/${id}`, patch, SupportCompanyRow);
export const impersonate = (id: string) =>
  api.post(`/support/companies/${id}/impersonate`, undefined, SupportImpersonateResponse);

export const qk = {
  me: () => ['support', 'me'] as const,
  companies: () => ['support', 'companies'] as const,
  company: (id: string) => ['support', 'companies', id] as const,
};
